import {
    BreadcrumbComponent as SourceBreadcrumbComponent,
} from 'SourceComponent/Breadcrumb/Breadcrumb.component';
import React from 'react';
import './Breadcrumb.override.style';
import Link from '@scandipwa/scandipwa/src/component/Link';
import TextPlaceholder from '@scandipwa/scandipwa/src/component/TextPlaceholder';
import ChevronIcon from '@scandipwa/scandipwa/src/component/ChevronIcon';

export class BreadcrumbComponent extends SourceBreadcrumbComponent {
    renderLink() {
        const {
            index,
            isDisabled,
            name,
        } = this.props;

        const url = this.getLinkUrl();
        const nameToString = String(name);

        return (
            <Link
                block="Breadcrumb"
                elem="Link"
                to={url}
                tabIndex={isDisabled ? -1 : 0}
            >
                <span className="Breadcrumb-Link-Name">
                    <TextPlaceholder content={nameToString} />
                </span>
                <ChevronIcon />
            </Link>
        );
    }

    render() {
        const { index } = this.props;

        return (
            <li
                className="Breadcrumb"
                key={index}
            >
                {this.renderLink()}
            </li>
        );
    }
}

export default BreadcrumbComponent;
